import React, { useMemo } from 'react';
import { DashboardPanel } from '../DashboardPanel';
import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { TotalCostPanelBody } from './TotalCostPanelBody';
import {
  DASHBOARD_CURRENCY,
  useDashboardFilteredTransactions,
  useDashboardFilteredVehicles,
} from '../../../../state/transactions/transactionFilterSlice';
import { UserManualLink } from '../../../../components/dialog/userManualDialog/UserManualLink';
import { userManualDialogChapters } from '../../../../state/dialogs/chapters';

export const TotalCostPanel: React.FC = () => {
  const { vehicles, isLoading: isLoadingVehicles } =
    useDashboardFilteredVehicles();
  const {
    filteredTransactions: transactions,
    isLoading: isLoadingTransactions,
  } = useDashboardFilteredTransactions();

  const totalAmount = useMemo(() => {
    return transactions.reduce(
      (sum, t) => sum + parseFloat(t.dashboardAmount?.amountNet ?? '0'),
      0,
    );
  }, [transactions]);

  const averagePerVehicle = vehicles.length ? totalAmount / vehicles.length : 0;

  return (
    <DashboardPanel
      header={
        <div className={'display-flex align-items-center'}>
          <CustomFormattedMessage id={'dashboard.panels.totalCost.header'} />
          <div
            data-testid="dashboard-total-cost-information-icon-wrapper"
            className={'margin-left-5'}
          >
            <UserManualLink
              chapter={userManualDialogChapters.dashboardDashboardFunctions}
              dataTestId="user-manual-link-total-cost"
            />
          </div>
        </div>
      }
      testId="dashboard-total-costs-panel"
      body={
        <TotalCostPanelBody
          loading={isLoadingVehicles || isLoadingTransactions}
          averagePerVehicle={averagePerVehicle}
          currency={DASHBOARD_CURRENCY}
          totalAmount={totalAmount}
        />
      }
    />
  );
};
